// ============================================================================
// OBT — Kabuk (rol → panel yönlendirmesi)
// ============================================================================
// Rol paneli seçimi tek bir eşleme üzerinden yapılır; bileşen içinde uzun
// koşul zincirleri kurulmaz. Yeni bir rol eklenirse yalnız `obtRoles.js` ve
// buradaki eşleme güncellenir.
// ============================================================================

import { useObtAccess } from './ObtAccessGuard';
import { ObtUnauthorized } from './ObtStates';
import ObtDirectorDashboard from './dashboards/ObtDirectorDashboard';
import ObtDeputyDirectorDashboard from './dashboards/ObtDeputyDirectorDashboard';
import ObtRegionEngineerDashboard from './dashboards/ObtRegionEngineerDashboard';
import ObtForemanDashboard from './dashboards/ObtForemanDashboard';

const DASHBOARDS = Object.freeze({
  director: ObtDirectorDashboard,
  deputy: ObtDeputyDirectorDashboard,
  engineer: ObtRegionEngineerDashboard,
  foreman: ObtForemanDashboard,
});

export default function ObtShell() {
  const { ready, allowed, dashboardKind } = useObtAccess();
  const Dashboard = dashboardKind ? DASHBOARDS[dashboardKind] : null;

  // Kapıdan geçildiği hâlde eşleme bulunamazsa fail-closed davranılır.
  if (!Dashboard) {
    return (
      <ObtUnauthorized message="Rolünüz için tanımlı bir OBT paneli bulunmuyor." />
    );
  }

  // Yetki henüz kesinleşmemişken istek atılmaz (gereksiz 401/403 üretilmez).
  return <Dashboard enabled={ready && allowed} />;
}
